import { render, staticRenderFns } from "./HealthQuestionForm.vue?vue&type=template&id=f0dcf586&"
import script from "./HealthQuestionForm.vue?vue&type=script&lang=js&"
export * from "./HealthQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./HealthQuestionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports